import { Container } from "@mui/material";
import { useContainerStyles } from "../_styles/container.styles";
import { FormManage } from "./form-manage";

export function FormPageManage() {

    return (
        <Container>

            <FormManage />

        </Container>
    );

}
